// extracted by mini-css-extract-plugin
export var promotionLink = "_wb-0";